import { Col, Row } from "react-bootstrap";
import SiteEnergySource from "../../../../../shared/components/site-energy-source/site-energy-source";
import EnergyFlowImg from "../../../../../shared/oversight-core/assets/images/good-we-energy-flow-center.svg";
import { IPowerHubSolarPlantView } from "../../../../../shared/oversight-core/interfaces/powerhub-solar-plant-view";
import EnergyFlowNode from "../../../../../shared/oversight-core/shared-components/energy-flow-node/energy-flow-node";
import EnergyFlowPath from "../../../../../shared/oversight-core/shared-components/energy-flow-path/energy-flow-path";
import Helper from "../../../../../shared/oversight-core/utils/helpers";
import translate from "../../../../../shared/oversight-core/utils/translate";
import { batteryFlowLabel } from "./battery-flow-label";
import styles from "./energy-flow.module.scss";

interface IProps {
  solarPlant: IPowerHubSolarPlantView;
  plantStatus: string;
}

const chartData: { value: number }[] = [
  { value: 100 },
  { value: 130 },
  { value: 210 },
  { value: 190 },
  { value: 240 },
  { value: 300 },
  { value: 220 },
  { value: 240 },
  { value: 190 },
  { value: 230 },
];

const PowerHubEnergyFlow = (props: IProps) => {
  const { solarPlant, plantStatus } = props;

  return (
    <div className={styles.powerHubEnergyFlowContainer}>
      <EnergyFlowNode
        x={315}
        y={0}
        title="Grid"
        value={
          solarPlant.liveGridPowerWatts
            ? `${Number(Helper.roundTo2(solarPlant.liveGridPowerWatts))} W`
            : ``
        }
        icon="flash_on"
        iconColor="#3E6E8C"
        iconBgColor="#EEF6F8"
        siteEnergySource={
          <SiteEnergySource
            data={chartData}
            stopColor="#29B4CC14"
            stroke="#299BCC80"
            id="colorUv"
          />
        }
        hideArrowIcon
      />
      <EnergyFlowNode
        x={0}
        y={450}
        title={batteryFlowLabel(solarPlant.liveBatteryPowerWatts)}
        value={
          solarPlant.batteryPercentageCharged
            ? `${Number(Helper.roundTo2(solarPlant.batteryPercentageCharged))} %`
            : ``
        }
        value2={
          solarPlant.liveBatteryPowerWatts
            ? `${Number(Helper.roundTo2(Math.abs(solarPlant.liveBatteryPowerWatts)))} W`
            : ``
        }
        icon="battery_charging_80"
        iconColor="#5E45B8"
        iconBgColor="#EFEEF8"
        siteEnergySource={
          <SiteEnergySource
            data={chartData}
            stopColor="#4C29CC14"
            stroke="#4C29CC59"
            id="colorUx"
          />
        }
        hideArrowIcon
      />
      <EnergyFlowNode
        x={315}
        y={450}
        title="PV Inverter"
        value={
          solarPlant.livePvPowerWatts
            ? `${Number(Helper.roundTo2(solarPlant.livePvPowerWatts))} W`
            : ``
        }
        icon="light_mode"
        iconColor="#D08700"
        iconBgColor="#F9F0E0"
        siteEnergySource={
          <SiteEnergySource
            data={chartData}
            stopColor="#D0870014"
            stroke="#D0870080"
            id="colorUc"
          />
        }
        hideArrowIcon
      />
      <EnergyFlowNode
        x={640}
        y={230}
        title="Load"
        value={
          solarPlant.liveLoadPowerWatts
            ? `${Number(Helper.roundTo2(solarPlant.liveLoadPowerWatts))} W`
            : ``
        }
        icon="smart_outlet"
        iconColor="#E45151"
        iconBgColor="#FAF4F4"
        siteEnergySource={
          <SiteEnergySource
            data={chartData}
            stopColor="#E4515114"
            stroke="#E4515180"
            id="colorUq"
          />
        }
        hideArrowIcon
      />
      <EnergyFlowPath // Grid path
        x={395}
        y={90}
        direction={solarPlant.liveGridPowerWatts < 0 ? `up` : `down`}
        isActive={
          solarPlant.liveGridPowerWatts
            ? solarPlant.liveGridPowerWatts !== 0
            : false
        }
        d={`m 55 0 l 0 200`}
      />
      <EnergyFlowPath // Battery path
        x={70}
        y={475}
        direction={solarPlant.liveBatteryPowerWatts < 0 ? `up` : `down`}
        isActive={
          solarPlant.liveBatteryPowerWatts
            ? solarPlant.liveBatteryPowerWatts !== 0
            : false
        }
        d={`m 57 0 l 0 -60 l 320 0`}
      />
      <EnergyFlowPath // PV Inverter path
        x={395}
        y={421}
        direction="up"
        isActive={
          solarPlant.livePvPowerWatts
            ? solarPlant.livePvPowerWatts !== 0 &&
              solarPlant.livePvPowerWatts > 0
            : false
        }
        d={`m 55 -5 l 0 50`}
      />
      <EnergyFlowPath // PV Inverter and Battery Common path
        x={395}
        y={300}
        direction={
          solarPlant.livePvPowerWatts > 0 ||
          (!solarPlant.livePvPowerWatts && solarPlant.liveBatteryPowerWatts > 0)
            ? `up`
            : `down`
        }
        isActive={
          solarPlant.livePvPowerWatts
            ? solarPlant.livePvPowerWatts !== 0
            : false || solarPlant.liveBatteryPowerWatts
              ? solarPlant.liveBatteryPowerWatts !== 0
              : false
        }
        d={`m 55 0 l 0 114`}
      />
      <EnergyFlowPath // Load path
        x={400}
        y={300}
        direction={solarPlant.liveLoadPowerWatts < 0 ? `up` : `down`}
        isActive={
          solarPlant.liveLoadPowerWatts
            ? solarPlant.liveLoadPowerWatts !== 0
            : false
        }
        d={`m 85 0 l 0 0 l 170 0`}
      />
      <div
        className="position-absolute"
        style={{ left: 398 + "px", top: 240 + "px" }}
      >
        <Row className={`${styles.energyFlowCenterTop} mx-0`}>
          <Col className="text-center">
            <img src={EnergyFlowImg} alt="Energy Flow" />
          </Col>
        </Row>
        <Row className={`${styles.energyFlowCenterBottom} mx-0`}>
          <Col className="text-center text-primary font-weight-400 font-size-12">
            {translate(plantStatus)}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PowerHubEnergyFlow;
